import React from 'react';
import { View, Image, Text, TouchableOpacity } from 'react-native';
import { styles } from './styles';
import type { DbChatAvatarProps, SenderType } from './types';

/** 根据发送者类型获取默认配置 */
const AVATAR_CONFIG: Record<SenderType, { bg: string; icon: string }> = {
    user: { bg: '#007AFF', icon: '我' },
    ai: { bg: '#5AC8FA', icon: 'AI' },
    'customer-service': { bg: '#FF9500', icon: '客' },
    system: { bg: '#C7C7CC', icon: '系' },
};

const DbChatAvatar: React.FC<DbChatAvatarProps> = ({
    source,
    senderType,
    size = 40,
    style,
    onPress,
}) => {
    const config = AVATAR_CONFIG[senderType];

    const avatarContent = source ? (
        <Image
            source={{ uri: source }}
            style={[
                styles.image,
                { width: size, height: size, borderRadius: size / 2 },
            ]}
        />
    ) : (
        <View
            style={[
                styles.placeholder,
                {
                    width: size,
                    height: size,
                    borderRadius: size / 2,
                    backgroundColor: config.bg,
                },
            ]}
        >
            <Text style={[styles.placeholderText, { fontSize: size * 0.35 }]}>
                {config.icon}
            </Text>
        </View>
    );

    if (onPress) {
        return (
            <TouchableOpacity style={style} onPress={onPress} activeOpacity={0.7}>
                {avatarContent}
            </TouchableOpacity>
        );
    }

    return <View style={style}>{avatarContent}</View>;
};

DbChatAvatar.displayName = 'DbChatAvatar';

export default DbChatAvatar;
export type { DbChatAvatarProps, SenderType } from './types';
